<template>
  <section style="height: 100%" class="d-flex align-center">
    <v-container>
      <v-row class="d-flex justify-center">
        <v-col cols="11" md="4" class="pa-0">

          <v-form @submit="resetPassword">
            <v-card color="blur">
              <v-card-text style="color: #eeeeee" class="text-center">
                <h2 class="ma-0">Reset password</h2>
              </v-card-text>
              <v-divider></v-divider>
<!--              <v-card-text style="color: #eeeeee" class="text-center">-->
<!--                <p class="ma-0">Please provide your email.</p>-->
<!--                We will send you instructions on how to reset your password. If you have not recived them, please check your spam-folder.-->
<!--              </v-card-text>-->
              <v-card-text class="pb-0">

                <v-text-field
                    v-model="code"
                    class="mb-3"
                    color="success"
                    label="Code from e-mail"
                    prepend-icon="mdi-email"
                    :error-messages="api_errors['code']"
                    required solo-inverted
                    type="number"
                />
                <v-text-field
                    v-model="password"
                    class="mb-3"
                    color="success"
                    label="Password"
                    prepend-icon="mdi-lock-outline"
                    :error-messages="api_errors['password']"
                    required solo-inverted
                    :type="passwordType ? 'password' : 'text'"
                >
                  <v-icon slot="append" color="primary" @click="passwordType = !passwordType">
                    {{ passwordType ? 'mdi-eye' : 'mdi-eye-off' }}
                  </v-icon>
                </v-text-field>
                <v-text-field
                    v-model="password_confirmation"
                    class="mb-3"
                    color="success"
                    label="Password confirmation"
                    prepend-icon="mdi-lock-outline"
                    :error-messages="api_errors['password']"
                    required solo-inverted
                    :type="confirmPasswordType ? 'password' : 'text'"
                >
                  <v-icon slot="append" color="primary" @click="confirmPasswordType = !confirmPasswordType">
                    {{ confirmPasswordType ? 'mdi-eye' : 'mdi-eye-off' }}
                  </v-icon>
                </v-text-field>
              </v-card-text>
              <v-card-actions class="justify-center">
                <v-btn color="success box-shadow" type="submit" block>
                  Let's Go
                </v-btn>
              </v-card-actions>
              <v-card-actions class="justify-center">
                <v-btn text small class="ma-0" color="white" :to="{name: 'Login'}">
                  Back to Sign in
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import {mapMutations} from "vuex";
export default {
  data: () => ({
    code: '',
    password: '',
    password_confirmation: '',
    confirmPasswordType: true,
    passwordType: true,
    api_errors: []
  }),
  methods: {
    ...mapMutations({
      setAuthUser: 'SET_AUTH_USER',
      setAuthToken: 'SET_AUTH_TOKEN',
      clearStorage: 'CLEAR_STORAGE',
    }),
    resetPassword (e) {
      e.preventDefault()
      this.api_errors = []
      this.axios.post('api/password/reset', {
        code: this.code,
        email: localStorage.getItem('tmpEmail'),
        password: this.password,
        password_confirmation: this.password_confirmation,
      })
          .then(({data}) => {
            localStorage.removeItem('tmpEmail')
            this.setAuthToken(data.data.access_token)
            // this.setAuthUser(data.data.user)
            this.$router.push('/')
          })
          .catch(errors => {this.api_errors = errors.response.data.errors })
    },
  },
}
</script>